export type SortMethodsMap<T> = Record<
  `${SortMethodTypes}`,
  Record<'method', (sortKey: string) => (a?: T, b?: T) => number>
>

export enum SortMethodTypes {
  NONE = 'none',
  ASC = 'asc',
  DESC = 'desc'
}
